export const strings = {
    personalise: 'Personalise',
    firmName: 'Firm name',
    adviserName: 'Adviser name',
    logo: 'Logo',
    imageUploadHelpText: 'Drag a JPG, PNG or SVG under 5mb here to upload your logo.',
    scalingHelpText: 'To achieve the best results, you can scale your logo to fit your report.',
    includeWelcomeNote: 'Include a welcome note for your client (shown on the front page)',
    includeIntroductionNote: 'Include an introduction (shown at the start of the report)',
    includeFinalComment: 'Include a summary (shown at the end of the report)',
    rememberDetails: 'Remember firm name, adviser name and logo for future use',
};
